import { Nullable } from "./common";

import { Pageable } from "../services/talkServices";

export type EvacuationStatusType =
  | "HELP_ME"
  | "ON_LEAVE_OR_OUT"
  | "CREATED_NO_RESPONSE"
  | "EVACUATION_COMPLETE";

export type SituationStatusType = "CREATED" | "IN_PROGRESS" | "ENDED";

export type EmergencySituationType = {
  evacuationId: string;
  incidentAddress: string;
  incidentFloor: string;
  incidentFloorName: string;
  evacuationCategory: string;
  shelterId: string;
  shelterName: string;
  isMember: Nullable<boolean>;
  shelterCoordinateList: ShelterCoordinate[];
  shelterDescription: string;
  userStatus: EvacuationStatusType;
  rescueLocation: Nullable<string>;
  shelterLat: Nullable<number>;
  shelterLng: Nullable<number>;
  shelterImg: {
    items: FileInfo[];
  };
  status: SituationStatusType;
  isExternal: boolean;

  incidentBuildingId: string;
  incidentBuildingName: string;

  // 건물 그룹 중앙 좌표 for FO 지도 출력
  lat: Nullable<number>;
  lng: Nullable<number>;
};

export type FileInfo = {
  fileId: number;
  scale: string;
  sortOrder: number;
  url: string;
};

export type ShelterCoordinate = {
  lat: number;
  lng: number;
  sortOrder?: Nullable<number>;
};

export type EmergencyStatusType = {
  status: EvacuationStatusType;
  rescueLocation?: string | null;
};

export type EmergencyQrJsonCode = {
  shelterId: string;
  createdAdminId: number | null;
};

export type EmergencyNfcType = {
  shelterId: string;
};

export type EmergencyGpsType = {
  lat: number;
  lng: number;
};

export type EmergencyBleType = {
  shelterId: string;
  createAdminId: Nullable<number>;
};

export type EvacueeCountRequest = {
  evacuationGroupId: string;
  evacuationId: string;
  evacuationCompanyId?: string;
  evacuationDepartmentName?: string;
  ignoreManager?: boolean;
  status?: string;
  name?: string;
};

export type EvacueeListRequest = {
  evacuationGroupId: string;
  evacuationId: string;
  evacuationCompanyId?: string;
  evacuationDepartmentName?: string;
  ignoreManager?: boolean;
  status?: string;
  name?: string;
  page?: number;
  pageSize?: number;
};

export type EvacueeListType = {
  pageable: Pageable;
  items: EvacueeItems[];
};

export type EvacueeItems = {
  isManager: boolean;
  evacuationBuildingId: string;
  evacuationBuildingName: string;
  evacuationEvacueeMapUuid: string;
  evacuationGroupId: string;
  evacuationId: string;
  evacueeId: string;
  name: string;
  evacuationCompanyId: string;
  evacuationCompanyName: string;
  evacuationDepartmentName: string;
  mobileNumber: string;
  status: string; // CREATED_NO_RESPONSE | EVACUATION_COMPLETE | ON_LEAVE_OR_OUT | HELP_ME
  modifiedBy: number;
  modifiedAt: string;
};

export type EvacueeListCountType = {
  situationId: string;
  totalCount: number;
  createdNoResponseCount: number;
  evacuationCompleteCount: number;
  onLeaveOrOut: number;
  helpMeCount: number;
};

export type EvacueeBuildingListType = {
  evacuationBuildingId: string;
  evacuationBuildingName: string;
};

export type EvacueeCompanyList = {
  evacuationCompanyId: string;
  evacuationCompanyName: string;
};

export type EvacueeDepartmentList = {
  evacuationDepartmentName: string;
};

export type EvacueeRequest = {
  name: string;
  mobileNumber: string;
  evacuationBuildingId: string;
  evacuationCompanyId: string;
  evacuationDepartmentName: string;
  evacuationFloorId: string;
  evacuationGroupId: string;
  evacuationId: string;
  status: EvacuationStatusType;
};

export type EvacuationUserAddition = {
  name: string;
  mobileNumber: string;
  evacuationBuildingId: string;
  evacuationCompanyId: string;
  evacuationFloorId: string;
  evacuationGroupId: string;
  evacuationDepartmentName: string;
  evacuationId: string;
  role: string;
};


export type EvacueeStatusRequest = {
  status: EvacuationStatusType;
};

export const GpsCallTimeoutIosMS = 5000;
export const GpsCallTimeoutMS = 8000;
